import React from "react";
import { FlexColumn, FlexRow } from "@/ui/FlexContainer/FlexContainer";
import Typography from "@/ui/Typography/Typography";
import { Balance } from "@/components/Balance/Balance";
import { HeaderIcon } from "@/assets/icons";
import cls from "./styles.module.scss";

export const Header = () => {
  return (
    <FlexRow justifyContent="space-between">
      <FlexRow gap={10}>
        <div className={cls.headerIcon}>
          <HeaderIcon />
        </div>

        <FlexColumn gap={0}>
          <Typography variant="body4">Богатый Курьер</Typography>
          <Typography className={cls.desc}>Реферальная программа</Typography>
        </FlexColumn>
      </FlexRow>

      <Balance />
    </FlexRow>
  );
};
